<template>
  <div>
    <!-- begin 弹层 -->
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="
              errorDialog = false;
              tip = '';
            "
          >
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end 弹层 -->

    <!-- begin 下单成功弹层 -->
    <v-dialog v-model="orderDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t("checkout.order_title") }}
        </v-card-title>
        <v-card-text>
          <div class="dialog-text">
            <div class="name">{{ orderDetail.serialNumber }}</div>
            <div>{{ $t("checkout.order_num") }} {{ orderDetail.no }}</div>
            <div>{{ $t("checkout.order_tip") }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="goToOrder">
            {{ $t("checkout.tip_confrim") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end 下单成功弹层 -->

    <v-container>
      <!-- begin 请输入取单人姓名 -->
      <div class="remark-container people-container">
        <div>{{ $t("checkout.people") }}</div>
        <input v-model="userName" />
      </div>
      <!-- end 请输入取单人姓名 -->

      <!-- begin 已点菜品 -->
      <v-layout justify-center :column="breakpoint.mdAndDown">
        <v-flex class="your-order-container" xs6>
          <div class="your-order-title">
            {{ $t("checkout.your_order_title") }}
          </div>
          <table class="order-table">
            <tr
              class="order-item"
              v-for="(item, index) in cart.items"
              :key="index"
            >
              <td>
                <img class="delivery_cover" :src="item.delivery.cover.url" />
              </td>
              <td>
                <div @click="goToDetail(item.guid)" class="name-row">
                  <div>{{ item.delivery.name }}</div>
                  <div class="description">{{ item.delivery.description }}</div>
                </div>
                <div
                  class="garnish-container"
                  v-if="item.garnish_items && item.garnish_items.length != 0"
                >
                  <div
                    class="garnish-item"
                    v-for="(garnish_item, garnish_index) in item.garnish_items"
                    :key="garnish_index"
                  >
                    <div class="commodity_name_row">
                      <div>{{ garnish_item.commodity_name }}</div>
                      <div>{{ garnish_item.price }}€</div>
                    </div>
                  </div>
                </div>
                <div class="attr-tag">
                  <span
                    v-for="(attr_item, index) in item.delivery.attributes"
                    :key="index"
                  >
                    <span v-if="attr_item.check">{{ attr_item.name }}</span>
                  </span>
                </div>
              </td>
              <td class="price">
                <div class="unit-price">
                  {{
                    (item.num * parseFloat(item.delivery.price))
                      | fixed(2, true)
                  }}€
                </div>
                <v-btn
                  fab
                  dark
                  outline
                  small
                  color="primary"
                  class="stepper"
                  @click="handleMinusFromCart(item.guid, index)"
                >
                  <v-icon dark>remove</v-icon>
                </v-btn>
                <strong class="num">{{ item.num }}</strong>
                <v-btn
                  fab
                  dark
                  outline
                  small
                  color="primary"
                  class="stepper"
                  @click="handleAddToCart(item.guid, index)"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
      <!-- end 已点菜品 -->

      <!-- begin 小计 -->
      <div class="total-container">
        <div>{{ $t("checkout.subtotal") }}</div>
        <strong class="total-price"
          >{{
            actuallyPaidAmount != 0
              ? actuallyPaidAmount
              : cartsInfo.actuallyPaidAmount
          }}
          €</strong
        >
      </div>
      <!-- end 小计 -->

      <!-- begin 备注 -->
      <div class="remark-container">
        <div>{{ $t("checkout.remark") }}</div>
        <textarea v-model="remark" />
      </div>
      <!-- end 备注 -->

      <div class="footer-container">
        <button class="button shadow goon-button" @click="backHome">
          {{ $t("checkout.continue") }}
        </button>

        <button
          class="button shadow place-order-button"
          @click="handleSubmit"
          loading
          :disabled="!canSubmit"
        >
          {{ $t("checkout.title") }}

          <v-progress-circular
            :size="16"
            :width="1"
            color="#fff"
            indeterminate
            v-if="pageLoading"
          ></v-progress-circular>
        </button>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Store from "../../../api/store";
import { fixed } from "../../../utils";

export default {
  data() {
    return {
      paymentMethod: "",
      addressGuid: null,
      deliveryFee: {
        fee: 0
      },
      errorDialog: false,
      orderDialog: false,
      tip: "",
      total: 0,
      discount: 0,
      discountAmount: 0,
      actuallyPaidAmount: 0,

      // 备注
      remark: "",

      // 取单人姓名
      userName: "",

      // 下单成功后信息
      orderDetail: {},

      pageLoading: false,

      canSubmit: true
    };
  },
  mounted() {
    this.getStorePayment();

    if (this.cart.items.length == 0) {
      this.actuallyPaidAmount = 0;
    } else {
      const payload = {
        items: this.cart.items.map(item => {
          return {
            commodityGuid: item.delivery.guid,
            quantity: item.num,
            garnish: item.garnish
          };
        }),
        storeGuid: this.storeId
      };

      this.calculateOrder(payload);
    }
  },

  computed: {
    ...mapState([
      "storePayment",
      "addressList",
      "storeId",
      "guid",
      "cartsInfo"
    ]),
    ...mapGetters(["cart"]),
    checkedAddress() {
      return this.addressList.find(item => {
        return item.guid === this.addressGuid;
      });
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },
  methods: {
    ...mapMutations(["clearCart", "addToCart", "minusFromCart"]),
    ...mapActions(["getStorePayment"]),

    backHome() {
      this.$router.back();
    },
    async handleSubmit() {
      if (!this.userName) {
        this.tip = this.$t("checkout.people-tip");
        this.errorDialog = true;
        return;
      }

      this.pageLoading = true;
      this.canSubmit = false;

      const payload = {
        items: this.cart.items.map(item => {
          return {
            commodityGuid: item.delivery.guid,
            quantity: item.num,
            attributes: item.attributes,
            garnish: item.garnish
          };
        }),
        paymentMethod: this.paymentMethod,
        remarks: this.remark,
        userName: this.userName,
        clientType: 2
      };

      try {
        const {
          data: { isError, msg, data }
        } = await Store.createOrder(payload);

        if (isError) {
          this.tip = msg;
          this.errorDialog = true;
          return;
        }

        this.clearCart();
        this.orderDialog = true;
        this.orderDetail = data;
      } catch (e) {
        const {
          response: {
            data: { msg }
          }
        } = e;

        this.errorDialog = true;
        this.tip = msg;
      } finally {
        this.pageLoading = false;
        this.canSubmit = true;
      }
    },

    async calculateOrder(payload) {
      try {
        const {
          data: { isError, data }
        } = await Store.calculateOrder(payload);

        if (isError) {
          return;
        }

        this.total = data.total;
        this.discount = data.discount;
        this.discountAmount = data.discountAmount;
        this.actuallyPaidAmount = data.actuallyPaidAmount;
      } catch (e) {
        console.log(e);
      }
    },

    handleMinusFromCart(guid, index) {
      this.minusFromCart({
        num: 1,
        guid,
        index
      });
    },
    handleAddToCart(guid, index) {
      const payload = {
        guid,
        num: 1,
        index
      };

      this.addToCart(payload);
    },

    goToOrder() {
      this.$router.push("/home?storeGuid=" + this.storeId);
      this.orderDialog = false;
    },

    goToDetail(guid) {
      this.$router.push({
        name: "store/delivery/detail",
        params: { id: guid }
      });
    }
  },
  watch: {
    storePayment(value) {
      if (value.length < 0) {
        return;
      }

      const index = value.findIndex(item => {
        return item.systemName === this.paymentMethod;
      });

      if (index > -1) {
        return;
      }

      this.paymentMethod = value[0].systemName;
    },
    addressList(value) {
      if (value.length <= 0) {
        return;
      }

      const defaultAddress = value.find(item => {
        return item.defaultAddress;
      });

      this.addressGuid = defaultAddress.guid;
    },

    "cart.items"(items) {
      // 结算页清空的时候返回点餐页
      if (items.length == 0) {
        // this.$router.back();
        this.actuallyPaidAmount = 0;
      } else {
        const payload = {
          items: items.map(item => {
            return {
              commodityGuid: item.delivery.guid,
              quantity: item.num,
              garnish: item.garnish
            };
          }),
          storeGuid: this.storeId
        };

        this.calculateOrder(payload);
      }
    }
  },
  filters: {
    fixed
  }
};
</script>

<style scoped lang="sass" src="./checkout.sass"></style>
